import { gql } from '@apollo/client';
export const ASSIGN_ELIBRARY_TO_STUDENTS = gql`
  mutation AssignedElibrary(
    $class_idx: Int
    $limit_time: Int!
    $start_time: [String!]!
    $start_date: String!
    $end_date: String!
    $books_list: [String!]!
    $user_idx_list: [Int!]!
    $elibrary_time: String!
    $rowidx: Int
  ) {
    AssignedElibrary(
      class_idx: $class_idx
      limit_time: $limit_time
      start_time: $start_time
      books_list: $books_list
      user_idx_list: $user_idx_list
      start_date: $start_date
      end_date: $end_date
      elibrary_time: $elibrary_time
      rowidx: $rowidx
    )
  }
`;

//foreign key에 delete action을 cascade로 해 놓았기 때문에 관련된 데이터는 모두 삭제가 된다.
export const DELETE_ASSIGN_ELIBRARY = gql`
  mutation DeleteAssignedElibrary($idx: Int!) {
    DeleteAssignedElibrary(idx: $idx)
  }
`;
